export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["xs"] = "xs";
    Breakpoint["sm"] = "sm";
    Breakpoint["md"] = "md";
    Breakpoint["lg"] = "lg";
    Breakpoint["xl"] = "xl";
    Breakpoint["2xl"] = "2xl";
})(Breakpoint || (Breakpoint = {}));
